/*  Mantine/Recharts charts are rendered as an svg and therefore require set dimensions for their components.
    The design of combyn wants the longest y-axis label to be left-aligned with the title of the chart. Because of that
    the y-axis width has to change with the length of the longest label. The values below have been found out through testing,
    if the font or font size changes they need to be updated. If someone has a better idea how to do it feel free to share it :D
    (yes, this only handles values between 0 and 9999, but if the parameters used in combyn exeed that the patient/customer is probably not alive anymore)
*/

export function getAxisWidth(maxValue: number) {
  if (maxValue <= 8) {
    return 27;
  }
  if (maxValue <= 80) {
    return 32;
  }
  if (maxValue <= 800) {
    return 40;
  }
  return 47;
}
